import { computed, type WritableComputedRef } from 'vue';

type FilterValue = string | number;

type Selection = WritableComputedRef<FilterValue[] | undefined>;

// These filters reach the API as one value, not a list. With exactly two options, a
// partial selection is always a single value and a full selection is no filter at all.
export const scalarSelection = <T extends FilterValue>(get: () => T | undefined, set: (value?: T) => void): Selection =>
    computed({
        get: () => {
            const value = get();

            return undefined === value ? undefined : [value];
        },
        set: (selected) => set(undefined === selected ? undefined : (selected[0] as T)),
    });

export const listSelection = <T extends FilterValue>(
    get: () => T[] | undefined,
    set: (values?: T[]) => void
): Selection =>
    computed({
        get,
        set: (selected) => set(selected as T[] | undefined),
    });
